<cm-checkbox [(value)]="$isChecked" (valueChange)="onValueChange($event)">
    <ng-content></ng-content>
</cm-checkbox>
